function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': `application/${type}`
    }
  };
}
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.addOns = this.form.querySelector('[name=add-ons]');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.goQwickBtn = document.querySelector('#gokwik-buy-now');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      let formData;

      if (!this.addOns) {
        formData = new FormData(this.form);

        // Add quantity validation here
        const quantity = parseInt(formData.get('quantity'), 10);
        const availableStock = parseInt(this.form.getAttribute('data-available-stock'), 10);
        if (quantity <= 0) {
          this.goQwickBtn.setAttribute("disabled", "");
          this.submitButton.setAttribute("disabled", "");
          this.handleErrorMessage("Quantity must be greater than zero.");
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          return;  // Exit function to prevent submission
        }

        if (quantity > availableStock) {
          this.goQwickBtn.setAttribute("disabled", "");
          this.submitButton.setAttribute("disabled", "");
          this.handleErrorMessage("Quantity exceeds available stock.");
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          return;  // Exit function to prevent submission
        }

        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

      } else {
        const data = this.addOns.value.split(", ");
        formData = { items: [] };
        data.forEach(variant => {
          let obj = {};
          obj["id"] = parseInt(variant);
          obj["quantity"] = 1;
          formData.items.push(obj);
        });
        formData['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
        formData['sections_url'] = window.location.pathname;

        config.body = JSON.stringify(formData);
        config.headers['Content-Type'] = "application/json";
      }

      // Proceed with fetch and response handling
      fetch(`${routes.cart_add_url}${this.addOns ? ".js" : ""}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            //disable buy buttons when product added to cart and no stock left
            setTimeout(()=>{
              this.goQwickBtn.setAttribute("disabled", "");
            },"1000")
            this.submitButton.setAttribute("disabled", "");

            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }


    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
